import { combineReducers } from 'redux'
import { createMigrate, persistReducer, PersistConfig } from 'redux-persist'
import { MigrationManifest } from 'redux-persist/es/types'
import sessionStorage from 'redux-persist/lib/storage/session'

import { searchbarReducer as searchbar } from './searchbar'
import { reducer as user } from './user'
import { reducer as wishlist } from './wishlist'
import { filtersReducer as filters } from './filters'
import { bulkInquiryReducer } from './bulk-inquiry'
import BulkInquiryState from './bulk-inquiry/types'
import bulkInquiryMigrations from './bulk-inquiry/migrations'
import config from '../common/config'

const bulkInquiryStateReconciler = (
    inboundState: BulkInquiryState,
    _originalState: BulkInquiryState,
    reducedState: BulkInquiryState,
): BulkInquiryState => ({ ...reducedState, ...inboundState })

const bulkInquiryPersistConfig: PersistConfig<BulkInquiryState> = {
    key: 'bulkInquiry',
    version: 1,
    storage: sessionStorage,
    stateReconciler: bulkInquiryStateReconciler,
    migrate: createMigrate(bulkInquiryMigrations as unknown as MigrationManifest, {
        debug: config.environment !== 'production',
    }),
}

const bulkInquiry = persistReducer(bulkInquiryPersistConfig, bulkInquiryReducer)

const rootReducer = combineReducers({ searchbar, user, wishlist, filters, bulkInquiry })

export default rootReducer
